var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarRightOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15192_22)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15192_22",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0571289,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15192_22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10954 17.5C3.6512 17.5 3.25884 17.3368 2.93245 17.0104C2.60607 16.684 2.44287 16.2917 2.44287 15.8333V4.16667C2.44287 3.70833 2.60607 3.31597 2.93245 2.98958C3.25884 2.66319 3.6512 2.5 4.10954 2.5H15.7762C16.2345 2.5 16.6269 2.66319 16.9533 2.98958C17.2797 3.31597 17.4429 3.70833 17.4429 4.16667V15.8333C17.4429 16.2917 17.2797 16.684 16.9533 17.0104C16.6269 17.3368 16.2345 17.5 15.7762 17.5H4.10954ZM13.2762 15.8333H15.7762V4.16667H13.2762V15.8333ZM11.6095 15.8333V4.16667H4.10954V15.8333H11.6095Z",
    fill: "#6B7280"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15192_22"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarRightOutline);
export default __webpack_public_path__ + "static/media/Sidebar_Right_Outline.be7f860156edee3c9b9e8a879c816974.svg";
export { ForwardRef as ReactComponent };